import * as SYSTEM from '../constants/system.keys';
import { GET_API, POST_API } from './index';

export const getCustomerDevicesApi = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/customer-devices`,
    token,
    dataHeader,
    dataQuery,
  );
};

export const getExportReportsApi = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/account-reports`,
    token,
    dataHeader,
    dataQuery,
    {
      responseType: 'blob',
    },
  );
};

export const getExportReportLogsApi = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/action-logs`,
    token,
    dataHeader,
    dataQuery,
  );
};

export const getStatisticsApi = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/customer-reports/statistic`,
    token,
    dataHeader,
    dataQuery,
  );
};

export const getReportByNamespaceApi = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/customer-devices/report-by-namespace-for-customer?`,
    token,
    dataHeader,
    dataQuery,
  );
};

export const getReportNotificationsApi = async (
  token,
  dataHeader,
  dataQuery,
) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/notifications/report?`,
    token,
    dataHeader,
    dataQuery,
    {
      responseType: 'blob',
    },
  );
};
